import { Color } from '~common/model/basics';
import { getColorCode } from '~web/view/theme/colors';

export const getIconColor = (color: Color | string): string => {
  if (color.startsWith('#') || color.startsWith('rgb')) {
    return color;
  } else {
    return getColorCode(color as Color);
  }
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/icon.helper.ts